import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import DateRangeIndicator from '@common/components/DateRangeIndicator';
import { SectionWrapper } from '@common/components/BookingForms';

export const StyledDateRangeIndicator = styled(DateRangeIndicator)`
  font-size: 15px;
`;

export const FORMWIDTH = 812;

export const ExpandableSectionWrapper = styled(SectionWrapper)<{ expanded: boolean }>`
  max-height: ${({ expanded }) => (expanded ? '1000px' : '68px')};
  overflow-y: hidden;
  transition: max-height 0.5s ease-in-out;
  background-color: ${({ theme, expanded }) => (expanded ? '#ffffff' : theme.greyColors['grey-5'])};
`;

export const FormStepSectionWrapper = styled(SectionWrapper)<{ isLoggedIn?: boolean }>`
  height: fit-content;
  max-width: ${FORMWIDTH}px;
  width: ${FORMWIDTH}px;
  padding: 20px;
  justify-self: center;

  @media screen and (max-width: 850px) {
    width: 100%;
    max-width: 100%;
    padding: 1.5rem;
  }
`;

export const NotesWrapper = styled.div`
  margin: 30px 0px;
  max-width: 740px;

  label {
    display: flex;
    margin-bottom: 4px;
  }

  textarea {
    min-height: 155px;
  }

  ${media.xs`
    margin-top: 0;
  `}
`;

export const TablesDateContainer = styled.div`
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  h2 {
    margin: 0;
  }
`;

export const TablesSingleRestaurantContainer = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
`;

export const Separator = styled.div`
  height: 1px;
  width: 100%;
  border-bottom: 1px solid #efefef;
  transform: translateY(2px);
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 3px solid ${({ theme }) => theme.defaultColors.lighterGrey};
  justify-content: space-between;
  padding: 12px 20px;
`;

export const PageTitle = styled.h1<{ noBorder?: boolean }>`
  font-size: 36px;
  padding: 0 0 10px 0;
  margin: 0;
  font-family: ${({ theme }) => theme.headerFont};
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  color: ${({ theme }) => theme.sectionTitleColour};
  word-break: break-word;
  word-wrap: break-word;
  border-bottom: ${({ noBorder }) => (noBorder ? 'none' : '1px solid #d9d9d9')};
  border-bottom: 1px solid #d9d9d9;
  ${media.xl`
    font-size: 35px;
    margin-top: 0;
  `}
`;

export const PageSubtitle = styled.h2`
  font-size: 28px;
  margin: 0;
  font-family: ${({ theme }) => theme.headerFont};
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  color: ${({ theme }) => theme.sectionTitleColour};
  word-break: break-word;
  word-wrap: break-word;
  ${media.md`
    margin-top: 5px;
  `}
`;
